<template>
  <div>
    <filters-component v-model="filters" />
    <crud-component collection="document" :ui-schema="uiSchema" :filters="filters"/>
  </div>
</template>

<script>
import CrudComponent from '../components/CrudComponent.vue'
import FiltersComponent from '../components/FiltersComponent.vue'

export default {
  name: "inventory",
  components: {
    CrudComponent,
    FiltersComponent,
  },
  data: function() {
    return {
      filters: {},
      uiSchema: {
        "$..documents": {
          "readOnly": true,
          "x-itemTitle": "name",
          "x-options": {
            "arrayItemColProps": {
              cols: 4
            },
            "disableSorting": true,
            "objectContainerClass": "foo",
            "sectionsClass": "bar",
          }
        },
        "$..documents.items.properties.*": { "x-style": { "display": "none" } },
        "$..documents.items.properties._id": {
          "x-style": { "display": "block" },
          "x-display": "custom-qrcode-logo",
          "x-col": 6,
        },
        "$..documents.items.properties.name": {
          "x-style": { "display": "block" },
          "x-col": 6,
        },
      },
    }
  },
}
</script>
<style scoped>
</style>
